(function () {
  'use strict';

  var DISMISS_KEY = 'up_announcement_dismissed';
  var DEVICE_SEARCH_ALIASES = Object.freeze({
    apple: 'iPhone',
    samsung: 'Galaxy',
    google: 'Pixel',
    motorola: 'Motorola Edge',
    xiaomi: 'Xiaomi',
    redmi: 'Redmi',
    huawei: 'Huawei',
    honor: 'Honor',
    '苹果': 'iPhone',
    '三星': 'Galaxy',
    '谷歌': 'Pixel',
    '摩托罗拉': 'Motorola Edge',
    '小米': 'Xiaomi',
    '红米': 'Redmi',
    '华为': 'Huawei',
    '荣耀': 'Honor',
  });

  function isDesignMode() {
    return typeof window.Shopify !== 'undefined' && window.Shopify.designMode;
  }

  function hideAnnouncement(bar) {
    bar.classList.add('up-hidden');
    bar.setAttribute('aria-hidden', 'true');
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {
      /* storage may be unavailable; hiding still works for this page view */
    }
  }

  function normalizeDeviceSearchAlias(value) {
    var normalized = String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

    return DEVICE_SEARCH_ALIASES[normalized] || null;
  }

  function normalizePathname(pathname) {
    return pathname.replace(/\/+$/, '') || '/';
  }

  function handleDeviceSearchSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-device-search-alias]')) {
      return;
    }

    var input = form.elements.namedItem('q');
    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    var alias = normalizeDeviceSearchAlias(input.value);
    if (alias) {
      input.value = alias;
    }
  }

  function redirectDirectDeviceAlias() {
    var form = document.querySelector('form[data-device-search-alias]');
    if (!form) {
      return;
    }

    var currentUrl = new URL(window.location.href);
    var searchUrl = new URL(form.action, window.location.origin);
    if (normalizePathname(currentUrl.pathname) !== normalizePathname(searchUrl.pathname)) {
      return;
    }

    var alias = normalizeDeviceSearchAlias(currentUrl.searchParams.get('q'));
    if (!alias) {
      return;
    }

    currentUrl.searchParams.set('q', alias);
    if (!currentUrl.searchParams.has('type')) {
      currentUrl.searchParams.set('type', 'product');
    }
    window.location.replace(currentUrl.toString());
  }

  function debounce(fn, wait) {
    var t = null;
    return function () {
      var args = arguments;
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function initCarousels() {
    var carousels = document.querySelectorAll('[data-up-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('.up-carousel__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;

      var prev = carousel.querySelector('[data-up-carousel-prev]');
      var next = carousel.querySelector('[data-up-carousel-next]');
      var dotsBox = carousel.querySelector('[data-up-carousel-dots]');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoRotate = carousel.getAttribute('data-auto-rotate') === 'true';
      var interval = Number(carousel.getAttribute('data-interval')) || 5000;
      var timer = null;
      var index = 0;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        var slide = slides[index];
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: reduced ? 'auto' : 'smooth'
        });
        updateDots();
      }

      function updateDots() {
        if (!dotsBox) return;
        var dots = dotsBox.querySelectorAll('.up-carousel__dot');
        dots.forEach(function (dot, i) {
          if (i === index) {
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.removeAttribute('aria-selected');
          }
        });
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        if (!autoRotate || reduced) return;
        stop();
        timer = setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      if (dotsBox) {
        slides.forEach(function (slide, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'up-carousel__dot';
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.addEventListener('click', function () {
            goTo(i);
            start();
          });
          dotsBox.appendChild(dot);
        });
        updateDots();
      }

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index - 1);
          start();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1);
          start();
        });
      }

      var updateFromScroll = debounce(function () {
        var current = 0;
        var minDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            current = i;
          }
        });
        if (current !== index) {
          index = current;
          updateDots();
        }
      }, 80);
      track.addEventListener('scroll', updateFromScroll, { passive: true });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      start();
    });
  }

  document.addEventListener('submit', handleDeviceSearchSubmit);

  initCarousels();

  if (isDesignMode()) {
    return;
  }

  redirectDirectDeviceAlias();

  try {
    if (sessionStorage.getItem(DISMISS_KEY) === '1') {
      document.querySelectorAll('.announcement-bar').forEach(hideAnnouncement);
    }
  } catch (e) {
    /* ignore storage errors */
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-up-announcement-dismiss]');
    if (!button) {
      return;
    }
    var bar = button.closest('.announcement-bar');
    if (bar) {
      hideAnnouncement(bar);
    }
  });
})();
